module.exports = __webpack_public_path__ + "static/media/0296_Small.68775ab7.jpg";